"use client";
import { useEffect, useRef, useState } from "react";
import { usePathname, useRouter } from "@/i18n/navigation";
import styles from "../../components/common/fileUploadBox/fileUploadBox.module.css";
import fakeNameStyles from "./fakeNameGenerator.module.css";
import back from "../../../public/Images/back-icon.png";
import { saveAs } from "file-saver";
import Loader from "../Loader/Loader";
import { names } from "./names";

const zip = require("jszip")();

function OtherFormat({ Data }) {
  const Name = usePathname();
  const location = useRouter();
  const ref = useRef("");
  const humanNames = require("human-names");
  const [check, setCheck] = useState(false);
  const [checkAddress, setCheckAddress] = useState(false);
  const [checkZip, setCheckZip] = useState(false);
  const [uploadFile, setUploadFile] = useState({});
  const [downloadData, setDownloadData] = useState({});
  const [text1, setText1] = useState("");
  const [text2, setText2] = useState("");
  const [searchName, setSearchName] = useState("");
  const [fakeName, setfakeName] = useState("");
  const [fakeNames, setFakeNames] = useState<string[]>([]);
  type FakeNameResult = { name: string; job?: string; email?: string };
  const [fakeNameResults, setFakeNameResults] = useState<FakeNameResult[]>([]);
  const [fakeNameSex, setFakeNameSex] = useState<"any" | "female" | "male">("any");
  const [fakeNameLocale, setFakeNameLocale] = useState<string>("en");
  const [fakeNameQuantity, setFakeNameQuantity] = useState<number>(1);
  const [fakeNameFormat, setFakeNameFormat] = useState<
    "full" | "firstLast" | "lastFirst" | "withTitle"
  >("full");
  const [fakeNameIncludeExtras, setFakeNameIncludeExtras] = useState(false);
  const [copiedId, setCopiedId] = useState<string | null>(null);
  const [copyAllFeedback, setCopyAllFeedback] = useState(false);
  const [loading, setLoading] = useState(false);
  const [combineData, setCombineData] = useState("");
  const [combineDataShow, setCombineDataShow] = useState(false);
  const [text, setText] = useState([]);
  const [val, setVal] = useState("");
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    setUploadFile({ ...uploadFile, [e.target.name]: e.target.files[0] });
    setCheckZip(true);

    let files = e.target.files;
    for (let file = 0; file < e.target.files.length; file++) {
      zip.file(files[file].name, files[file]);
    }
    zip
      .generateAsync({ type: "blob", compression: "DEFLATE" })
      .then((content) => {
        const compressedFile = new File(
          [content],
          `${files[0].name.split(".")[0]}.zip`,
          {
            type: "application/zip",
          }
        );
        setDownloadData(compressedFile);
        let data = Object.keys(zip.files);
        for (let i = 0; i < data.length; i++) {
          zip.remove(data[i]);
        }
      });
  };

  const handleDownload = (url) => {
    saveAs(downloadData, `${uploadFile.file.name.split(".")[0]}.zip`);
    setCheckZip(false);
  };

  useEffect(() => {
    setCheck(false);
    setCheckAddress(false);
  }, [Name]);

  const [address, setAddress] = useState({
    building_number: "",
    city: "",
    city_suffix: "",
    country: "",
    postalcode: "",
    state: "",
    street_name: "",
  });

  const handleOnChange = (e) => {
    setText1(e.target.value);
    setErrors({ ...errors, [e.target.name]: "" });
  };
  const handleOnTwoChange = (e) => {
    setErrors({ ...errors, [e.target.name]: "" });
    setText2(e.target.value);
  };

  const n1 = text1.length;
  const text1Array = [];
  const n2 = text2.length;
  const text2Array = [];
  const text3Array = [];

  for (let i = 1; i < n1; i++) {
    text1Array.push(text1.slice(i));
    text1Array.push(text1.slice(0, i));
  }

  for (let i = 1; i < n2; i++) {
    text1Array.push(text2.slice(i));
    text2Array.push(text2.slice(0, i));
  }

  for (let i = 0; i < text1Array.length; i++) {
    for (let j = 0; j < text2Array.length; j++) {
      text3Array.push(text1Array[i] + text2Array[j]);
    }
  }

  for (let i = 0; i < text2Array.length; i++) {
    for (let j = 0; j < text1Array.length; j++) {
      text3Array.push(text2Array[i] + text1Array[j]);
    }
  }

  const handleOnCombineChange = (e) => {
    setErrors({ ...errors, [e.target?.name]: "" });
    setSearchName(e.target.value);
  };

  const searchVal = searchName?.toLowerCase();

  const handlecombine = (e) => {
    if (validateForm()) {
      setCombineDataShow(true);
      const CombineName = text3Array?.filter((element) =>
        element?.toLowerCase()?.match(searchVal)
      );
      setCombineData(CombineName);
    }
  };

  useEffect(() => {
    const CombineName = text3Array?.filter((element) =>
      element?.toLowerCase()?.match(searchVal)
    );
    setCombineData(CombineName);
  }, [searchVal]);

  const validateForm = () => {
    let formIsValid = true;
    let errors = {};

    if (!text1 || text1?.trim() === "") {
      formIsValid = false;
      errors["text1"] = "*Please Enter name";
    }
    if (!text2 || text2?.trim() === "") {
      formIsValid = false;
      errors["text2"] = "*Please Enter name";
    }
    setErrors(errors);
    return formIsValid;
  };

  const getName = async () => {
    if (Name !== "/fake-name-generator") return;
    setLoading(true);
    setCheck(false);
    try {
      const fakerModule =
        fakeNameLocale === "en"
          ? await import("@faker-js/faker")
          : await import(`@faker-js/faker/locale/${fakeNameLocale}`).catch(
              () => import("@faker-js/faker")
            );
      const f = fakerModule.faker;
      const sex =
        fakeNameSex === "any"
          ? undefined
          : (fakeNameSex as "female" | "male");
      const count = Math.min(20, Math.max(1, fakeNameQuantity));
      const includeExtras = fakeNameIncludeExtras;

      const results: FakeNameResult[] = Array.from({ length: count }, () => {
        const first = f.person.firstName(sex);
        const last = f.person.lastName(sex);
        let name: string;
        if (fakeNameFormat === "full") {
          name = f.person.fullName({ sex });
        } else {
          switch (fakeNameFormat) {
            case "firstLast":
              name = `${first} ${last}`;
              break;
            case "lastFirst":
              name = `${last}, ${first}`;
              break;
            case "withTitle": {
              const prefix = f.person.prefix(sex);
              const suffix = f.person.suffix();
              const full = `${first} ${last}`;
              name = [prefix, full, suffix].filter(Boolean).join(" ");
              break;
            }
            default:
              name = `${first} ${last}`;
          }
        }
        const entry: FakeNameResult = { name };
        if (includeExtras) {
          entry.job = f.person.jobTitle();
          entry.email = f.internet.email({ firstName: first, lastName: last });
        }
        return entry;
      });

      setFakeNameResults(results);
      setFakeNames(results.map((r) => r.name));
      setfakeName(results[0]?.name ?? "");
      setCheck(true);
    } catch (err) {
      console.error("Fake name generation failed:", err);
      setFakeNameResults([]);
      setFakeNames([]);
      setCheck(false);
    } finally {
      setLoading(false);
    }
  };

  const copyFakeName = (text: string, id: string) => {
    if (typeof navigator !== "undefined" && navigator.clipboard) {
      navigator.clipboard.writeText(text).then(() => {
        setCopiedId(id);
        setTimeout(() => setCopiedId(null), 2000);
      });
    }
  };

  const copyAllFakeNames = () => {
    if (fakeNameResults.length === 0) return;
    const hasExtras = fakeNameIncludeExtras && fakeNameResults[0]?.job;
    const text = hasExtras
      ? [
          "Name,Job,Email",
          ...fakeNameResults.map(
            (r) =>
              `"${(r.name ?? "").replace(/"/g, '""')}","${(r.job ?? "").replace(/"/g, '""')}","${(r.email ?? "").replace(/"/g, '""')}"`
          ),
        ].join("\n")
      : fakeNameResults.map((r) => r.name).join("\n");
    if (typeof navigator !== "undefined" && navigator.clipboard) {
      navigator.clipboard.writeText(text).then(() => {
        setCopyAllFeedback(true);
        setTimeout(() => setCopyAllFeedback(false), 2000);
      });
    }
  };

  const downloadFakeNames = (format: "txt" | "csv") => {
    if (fakeNameResults.length === 0) return;
    const hasExtras = fakeNameIncludeExtras && fakeNameResults[0]?.job;
    let content: string;
    let filename: string;
    let mime: string;
    if (format === "csv") {
      content = hasExtras
        ? [
            "Name,Job,Email",
            ...fakeNameResults.map(
              (r) =>
                `"${(r.name ?? "").replace(/"/g, '""')}","${(r.job ?? "").replace(/"/g, '""')}","${(r.email ?? "").replace(/"/g, '""')}"`
            ),
          ].join("\n")
        : ["Name", ...fakeNameResults.map((r) => `"${(r.name ?? "").replace(/"/g, '""')}"`)].join(
            "\n"
          );
      filename = "fake-names.csv";
      mime = "text/csv;charset=utf-8";
    } else {
      content = hasExtras
        ? fakeNameResults
            .map((r) => [r.name, r.job, r.email].filter(Boolean).join(" | "))
            .join("\n")
        : fakeNameResults.map((r) => r.name).join("\n");
      filename = "fake-names.txt";
      mime = "text/plain;charset=utf-8";
    }
    const blob = new Blob([content], { type: mime });
    saveAs(blob, filename);
  };

  const getAddress = async () => {
    setLoading(true);
    let dataAddress = new FormData();
    dataAddress.append("text_generation_type", Data.conversion_type);

    // ApiPost("v1/tool/text/fake_text", dataAddress)
    //   .then((res) => {
    //     setAddress(res.data.data);
    //     setCheckAddress(true);
    //     setLoading(false);
    //   })
    //   .catch((err) => {
    //     alert(err);
    //     setCheckAddress(false);
    //     setLoading(false);
    //   });
  };

  const handleOnChangefunction = (e) => {
    if (e.target.value == "names") {
      const namesString = names[e.target.value];
      setText(namesString);
    } else {
      const yourString = humanNames[e.target.value];
      setText(yourString);
    }
  };

  const HandleOnInputChange = (e) => {
    setVal(e.target.value);
  };

  const newVal = val?.toLowerCase();

  const greaterThanTen = text?.filter((element) =>
    element?.toLowerCase().match(newVal)
  );
  return (
    <div ref={ref}>
      {/* Fake Address Generator */}
      {Name === "/fake-address-generator" && (
        <div>
          <div className="button faek-genrate-add-button-center-alignment">
            <button onClick={() => getAddress()}>
              <span>Generate Address</span>
              {loading && <Loader />}
            </button>
          </div>
          {checkAddress == true ? (
            <div className="fake-genrate-add-box-design">
              <div className="text-grid">
                <div className="text-grid-items">
                  <p>Your building number is:</p>
                </div>
                <div className="text-grid-items">
                  <span>{address.building_number}</span>
                </div>
              </div>
              <div className="text-grid">
                <div className="text-grid-items">
                  <p>Your street name is:</p>
                </div>
                <div className="text-grid-items">
                  <span>{address.street_name}</span>
                </div>
              </div>
              <div className="text-grid">
                <div className="text-grid-items">
                  <p>Your city suffix is:</p>
                </div>
                <div className="text-grid-items">
                  <span>{address.city_suffix}</span>
                </div>
              </div>
              <div className="text-grid">
                <div className="text-grid-items">
                  <p>Your city is:</p>
                </div>
                <div className="text-grid-items">
                  <span> {address.city}</span>
                </div>
              </div>
              <div className="text-grid">
                <div className="text-grid-items">
                  <p> Your postalcode is:</p>
                </div>
                <div className="text-grid-items">
                  <span>{address.postalcode}</span>
                </div>
              </div>
              <div className="text-grid">
                <div className="text-grid-items">
                  <p>Your state is:</p>
                </div>
                <div className="text-grid-items">
                  <span>{address.state}</span>
                </div>
              </div>
              <div className="text-grid">
                <div className="text-grid-items">
                  <p>Your country is:</p>
                </div>
                <div className="text-grid-items">
                  <span>{address.country}</span>
                </div>
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      )}

      {/* Fake Name Generator – powered by Faker.js v10 */}
      {Name === "/fake-name-generator" && (
        <div className={fakeNameStyles.wrapper}>
          <div className={fakeNameStyles.optionsRow}>
            <div className={fakeNameStyles.optionGroup}>
              <label htmlFor="fake-name-locale">Locale</label>
              <select
                id="fake-name-locale"
                value={fakeNameLocale}
                onChange={(e) => setFakeNameLocale(e.target.value)}
              >
                <option value="en">English</option>
                <option value="de">German</option>
                <option value="es">Spanish</option>
                <option value="fr">French</option>
                <option value="it">Italian</option>
                <option value="nl">Dutch</option>
                <option value="pt_BR">Portuguese (BR)</option>
                <option value="ja">Japanese</option>
                <option value="ko">Korean</option>
                <option value="zh_CN">Chinese</option>
              </select>
            </div>
            <div className={fakeNameStyles.optionGroup}>
              <label htmlFor="fake-name-sex">Gender</label>
              <select
                id="fake-name-sex"
                value={fakeNameSex}
                onChange={(e) =>
                  setFakeNameSex(e.target.value as "any" | "female" | "male")
                }
              >
                <option value="any">Any</option>
                <option value="female">Female</option>
                <option value="male">Male</option>
              </select>
            </div>
            <div className={fakeNameStyles.optionGroup}>
              <label htmlFor="fake-name-format">Name format</label>
              <select
                id="fake-name-format"
                value={fakeNameFormat}
                onChange={(e) =>
                  setFakeNameFormat(
                    e.target.value as
                      | "full"
                      | "firstLast"
                      | "lastFirst"
                      | "withTitle"
                  )
                }
              >
                <option value="full">Full name</option>
                <option value="firstLast">First & Last</option>
                <option value="lastFirst">Last, First</option>
                <option value="withTitle">With title (prefix/suffix)</option>
              </select>
            </div>
            <div className={fakeNameStyles.optionGroup}>
              <label htmlFor="fake-name-qty">Quantity</label>
              <select
                id="fake-name-qty"
                value={fakeNameQuantity}
                onChange={(e) => setFakeNameQuantity(Number(e.target.value))}
              >
                <option value={1}>1</option>
                <option value={5}>5</option>
                <option value={10}>10</option>
                <option value={20}>20</option>
              </select>
            </div>
            <div className={fakeNameStyles.optionGroupCheck}>
              <input
                type="checkbox"
                id="fake-name-extras"
                checked={fakeNameIncludeExtras}
                onChange={(e) => setFakeNameIncludeExtras(e.target.checked)}
              />
              <label htmlFor="fake-name-extras">Include job & email</label>
            </div>
            <button
              type="button"
              className={fakeNameStyles.generateBtn}
              onClick={() => getName()}
              disabled={loading}
            >
              {loading ? (
                <>
                  <Loader />
                  <span>Generating…</span>
                </>
              ) : (
                "Generate names"
              )}
            </button>
          </div>
          {check && fakeNameResults.length > 0 && (
            <div className={fakeNameStyles.resultCard}>
              <div className={fakeNameStyles.resultHeader}>
                <span className={fakeNameStyles.resultTitle}>
                  {fakeNameResults.length === 1
                    ? "Generated name"
                    : "Generated names"}
                </span>
                <div className={fakeNameStyles.resultActions}>
                  <button
                    type="button"
                    className={`${fakeNameStyles.copyBtn} ${fakeNameStyles.copyAllBtn} ${copyAllFeedback ? fakeNameStyles.copied : ""}`}
                    onClick={copyAllFakeNames}
                  >
                    {copyAllFeedback ? "Copied!" : "Copy all"}
                  </button>
                  <span className={fakeNameStyles.downloadLabel}>Download:</span>
                  <button
                    type="button"
                    className={fakeNameStyles.downloadBtn}
                    onClick={() => downloadFakeNames("txt")}
                  >
                    TXT
                  </button>
                  <button
                    type="button"
                    className={fakeNameStyles.downloadBtn}
                    onClick={() => downloadFakeNames("csv")}
                  >
                    CSV
                  </button>
                </div>
              </div>
              {fakeNameResults.length === 1 ? (
                <div className={fakeNameStyles.singleResult}>
                  <div className={fakeNameStyles.singleRow}>
                    <span className={fakeNameStyles.singleName}>
                      {fakeNameResults[0].name}
                    </span>
                    <button
                      type="button"
                      className={`${fakeNameStyles.copyBtn} ${copiedId === "0" ? fakeNameStyles.copied : ""}`}
                      onClick={() =>
                        copyFakeName(fakeNameResults[0].name, "0")
                      }
                      aria-label="Copy name"
                    >
                      {copiedId === "0" ? "Copied!" : "Copy"}
                    </button>
                  </div>
                  {fakeNameIncludeExtras &&
                    (fakeNameResults[0].job || fakeNameResults[0].email) && (
                      <div className={fakeNameStyles.extrasRow}>
                        {fakeNameResults[0].job && (
                          <span className={fakeNameStyles.extraItem}>
                            <strong>Job:</strong> {fakeNameResults[0].job}
                          </span>
                        )}
                        {fakeNameResults[0].email && (
                          <span className={fakeNameStyles.extraItem}>
                            <strong>Email:</strong> {fakeNameResults[0].email}
                          </span>
                        )}
                      </div>
                    )}
                </div>
              ) : (
                <ul className={fakeNameStyles.nameList}>
                  {fakeNameResults.map((r, i) => (
                    <li
                      key={`${r.name}-${i}`}
                      className={fakeNameStyles.nameItem}
                    >
                      <div className={fakeNameStyles.nameItemContent}>
                        <span className={fakeNameStyles.nameItemName}>
                          {r.name}
                        </span>
                        {fakeNameIncludeExtras && (r.job || r.email) && (
                          <div className={fakeNameStyles.nameItemExtras}>
                            {r.job && (
                              <span className={fakeNameStyles.extraItem}>
                                {r.job}
                              </span>
                            )}
                            {r.email && (
                              <span
                                className={fakeNameStyles.extraItem}
                                title={r.email}
                              >
                                {r.email}
                              </span>
                            )}
                          </div>
                        )}
                      </div>
                      <button
                        type="button"
                        className={`${fakeNameStyles.copyBtn} ${copiedId === `name-${i}` ? fakeNameStyles.copied : ""}`}
                        onClick={() => copyFakeName(r.name, `name-${i}`)}
                        aria-label={`Copy ${r.name}`}
                      >
                        {copiedId === `name-${i}` ? "Copied!" : "Copy"}
                      </button>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          )}
        </div>
      )}

      {/* Create Zip */}
      {Name === "/create-zip" && (
        <>
          <div className={styles.fileUploadBoxDesign}>
            <div className="alignsettwo alignset button">
              {checkZip == true ? (
                <>
                  <h3> Your File is ready. </h3>
                  <br />
                  <button onClick={() => handleDownload()}>
                    <span>Download Zip File</span>
                  </button>
                  <br />
                  <br />

                  <h4 onClick={() => setCheckZip(false)}>
                    <img
                      src={back.src}
                      alt="back"
                      style={{ height: "12px", width: "25px" }}
                    />{" "}
                    Back to site.
                  </h4>
                </>
              ) : (
                <button className="justify-center">
                  <input
                    multiple
                    type="file"
                    name="file"
                    onChange={(e) => handleChange(e)}
                  />
                  <i className="fa-solid fa-upload"></i>
                  <span>Upload from PC or Mobile</span>
                </button>
              )}
            </div>
          </div>
        </>
      )}

      {/* SERACH NAME */}
      {Name === "/search-name" && (
        <>
          <div className="main-salary-calculator-box">
            <div className="salry-input">
              <div>
                <select
                  id="unit"
                  name="unit"
                  onChange={(e) => {
                    handleOnChangefunction(e);
                  }}
                >
                  <option disabled hidden>
                    Select Value
                  </option>
                  <option value="names">All Name</option>
                  <option value="femaleEn">English(Female)</option>
                  <option value="maleEn">English(Male)</option>
                  <option value="femaleFr">French(Female)</option>
                  <option value="maleFr">French(Male)</option>
                  <option value="femaleIt">Italian(Female)</option>
                  <option value="maleIt">Italian(Male)</option>
                  <option value="femaleDe">Deutch(Female)</option>
                  <option value="maleDe">Deutch(Male)</option>
                  <option value="femaleEs">Spanish(Female)</option>
                  <option value="maleEs">Spanish(Male)</option>
                  <option value="femaleNl">Dutch(Female)</option>
                  <option value="maleNl">Dutch(Male)</option>
                </select>
              </div>
            </div>
          </div>
          {/* </div> */}
          {text.length === 0 ? (
            ""
          ) : (
            <div className="main-salary-calculator-box searchNameAlignment">
              <div className="salry-input timerAlignment">
                <input
                  onChange={(e) => HandleOnInputChange(e)}
                  placeholder="Search Your Name Character Ex - A"
                ></input>
                <div className="new-flex-copy-new-align result-alignment">
                  <h4>Result :-</h4>
                </div>

                {greaterThanTen ? (
                  greaterThanTen.length === 0 ? (
                    <div className={styles.fileUploadBoxError}>
                      There are no Data
                    </div>
                  ) : (
                    <div className="five-grid-alignment">
                      {greaterThanTen?.map((item, index) => {
                        return <p key={index}>{item}</p>;
                      })}
                    </div>
                  )
                ) : (
                  <div className="five-grid-alignment">
                    {text?.map((item, index) => {
                      return <p key={index}>{item}</p>;
                    })}
                  </div>
                )}
              </div>
            </div>
          )}
        </>
      )}

      {/* name-combiner */}
      {Name === "/name-combiner" && (
        <>
          <div className="main-salary-calculator-box">
            <div className="two-col-grid ">
              <div className="salry-input">
                <input
                  placeholder="Enter Your Name"
                  value={text1}
                  name="text1"
                  onChange={(e) => handleOnChange(e)}
                  className={errors["text1"] && "error-input"}
                />
                <span className="text-sm text-red-700">{errors["text1"]}</span>
              </div>
              <div className="salry-input">
                <input
                  placeholder="Enter Your Name For Combine"
                  value={text2}
                  name="text2"
                  onChange={(e) => handleOnTwoChange(e)}
                  className={errors["text2"] && "error-input"}
                />
                <span className="text-sm text-red-700">{errors["text2"]}</span>
              </div>
            </div>
          </div>

          <div className="button faek-genrate-add-button-center-alignment">
            <button
              onClick={(e) => {
                handlecombine(e);
              }}
            >
              Combine
            </button>
          </div>

          {combineDataShow === true ? (
            <div className="main-salary-calculator-box searchNameAlignment">
              <div className="salry-input timerAlignment">
                <input
                  name="combine"
                  onChange={(e) => handleOnCombineChange(e)}
                  placeholder="Search Your Name Character Ex - A"
                />
                <div className="new-flex-copy-new-align result-alignment">
                  <h4>Result :-</h4>
                </div>
                {combineData ? (
                  combineData.length === 0 ? (
                    <div className={styles.fileUploadBoxError}>
                      There are no Data
                    </div>
                  ) : (
                    <div className="five-grid-alignment">
                      {combineData
                        ?.filter((element) =>
                          element?.toLowerCase()?.match(searchVal)
                        )
                        .map((item, index) => {
                          return <p key={index}>{item}</p>;
                        })}
                    </div>
                  )
                ) : (
                  <div className="five-grid-alignment">
                    {text3Array?.map((item, index) => {
                      return <p key={index}>{item}</p>;
                    })}
                  </div>
                )}
              </div>
            </div>
          ) : (
            ""
          )}
        </>
      )}
    </div>
  );
}

export default OtherFormat;
